import axios from "axios";

const getSeqInstallNo = async () => {
    return axios
        .get(`${process.env.REACT_APP_API_URL}/seqInstallJob/installNumber`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            throw err.response?.data || err;
        });
};

const getSeqInstallDetail = async (id) => {
    return axios
        .get(`${process.env.REACT_APP_API_URL}/seqInstallJob/installNumber/${id}`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            throw err.response?.data || err;
        });
};

const getSeqInstallService = async (id) => {
    return axios
        .get(`${process.env.REACT_APP_API_URL}/InformInstallJobs/service/${id}`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            throw err.response?.data || err;
        });
};

const getSeqInstallServiceStatus = async (id, date) => {
    return axios
        .get(`${process.env.REACT_APP_API_URL}/seqInstallJob/search?seq_install_no=${id}&seq_install_date=`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            throw err.response?.data || err;
        });
};

const SeqInstallJobsService = {
    getSeqInstallNo,
    getSeqInstallDetail,
    getSeqInstallService,
    getSeqInstallServiceStatus

};

export default SeqInstallJobsService;

